import { cn } from '../../lib/cn';
import type { MigrationRow } from '../../enterprisebeta/framework';

type Props = { migrations?: MigrationRow[] };

export function MigrationCenterPanel({ migrations = [] }: Props) {
  return (
    <div className="space-y-2">
      {migrations.map((m) => (
        <div key={m.type + m.tenant} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{m.type}</p>
              <p className="text-xs text-slate-500">{m.tenant}</p>
            </div>
            <span className={cn(
              'text-xs font-medium',
              m.status === 'completed' ? 'text-success-600' :
              m.status === 'in_progress' ? 'text-brand-600' : 'text-slate-500',
            )}>
              {m.status.replace('_', ' ')}
            </span>
          </div>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
            <div className={cn('h-full rounded-full', m.progress === 100 ? 'bg-success-500' : 'bg-brand-500')} style={{ width: `${m.progress}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
